export default __webpack_public_path__ + "static/media/milestone-tier-2.bf92255b.png";